import { useAppSelector } from 'hooks/useStore'
import { ReactElement, useEffect, useState } from 'react'
import { Theme } from 'theme/theme'
import { componentByMonth } from './dashboardFigures.helpers'
import { ApiArtizenBO } from 'utils/artizenConnector'
import { TArtisanStats } from '@Arti-zen/package-backoffice'
import { Button } from '@mui/material'
import { Format } from 'utils/format'

export default function DashboardOthersFigures(): ReactElement {
  const { dateStart, dateEnd } = useAppSelector((state) => state.dashboard)
  const [artisanStats, setArtisanStats] = useState<TArtisanStats['stats'] | null>(null)
  const [needRefresh, setNeedRefresh] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setNeedRefresh(true)
  }, [dateStart, dateEnd])

  const refresh = () => {
    setIsLoading(true)
    setNeedRefresh(false)

    ApiArtizenBO.artizenUsers
      .stats({
        excludedUserIdList: [],
        dateStart: dateStart?.toFormat('yyyy/MM/dd'),
        dateEnd: dateEnd?.toFormat('yyyy/MM/dd'),
      })
      .then((response) => setArtisanStats(response.stats))
      .finally(() => setIsLoading(false))
  }

  console.log('artisanStats', artisanStats)

  if (needRefresh) {
    return (
      <>
        <Button variant="contained" onClick={refresh}>
          Actualiser
        </Button>
      </>
    )
  }

  return isLoading ? (
    <>Chargement en cours ...</>
  ) : (
    <>
      <tr style={{ fontWeight: 600, color: Theme.colors.blueArtizen }}>
        <td>Autres</td>
      </tr>
      {!artisanStats ? null : (
        <>
          <tr>
            <td style={{ textAlign: 'right' }}>Abonnés</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => {
                return (
                  <td style={{ padding: 10, textAlign: 'center' }}>
                    <div>{Format.number(artisanStats[year]?.[month]?.artisanSubscriptedList.length)}</div>
                  </td>
                )
              },
            })}
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Sous-comptes</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => {
                return (
                  <td style={{ padding: 10, textAlign: 'center' }}>
                    <div>{Format.number(artisanStats[year]?.[month]?.artisanSubAccountList.length)}</div>
                  </td>
                )
              },
            })}
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Churn (nb)</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => {
                return (
                  <td style={{ padding: 10, textAlign: 'center' }}>
                    <div>{Format.number(artisanStats[year]?.[month]?.artisanChurnedList.length)}</div>
                  </td>
                )
              },
            })}
          </tr>
        </>
      )}
    </>
  )
}
